module.exports = __webpack_public_path__ + "img/download-5.1dca1686.png";